import { style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Inset review-gate card rendered in a task row's expansion (a full-width
// cell), so it reads as belonging to the row above it. Shows the document, the
// machine's claim in plain language, the fields it read, and Approve/Reject
// (TMF-227). Follows VerdictCard.css.ts / TaskTable.css.ts conventions.
export const panel = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.md,
  padding: vars.space.md,
  backgroundColor: vars.color.surfaceMuted,
  borderRadius: vars.radius.md,
});

export const docName = style({
  fontWeight: vars.fontWeight.semibold,
  color: vars.color.textDefault,
  fontSize: vars.fontSize.sm,
});

// The document preview sizes itself to its content so the card never scrolls
// on either axis (TMF-227 follow-up): an image keeps its natural aspect ratio
// across the card's full width…
export const previewImage = style({
  display: "block",
  width: "100%",
  height: "auto",
  border: `1px solid ${vars.color.borderSubtle}`,
  borderRadius: vars.radius.sm,
  backgroundColor: vars.color.surface,
});

// …and a PDF gets the browser's viewer in a full-page letter-aspect frame, so
// an entire page is visible at the card's width (multi-page documents page
// inside the viewer itself — the card never clips it).
export const previewPdf = style({
  display: "block",
  width: "100%",
  aspectRatio: "8.5 / 11",
  border: `1px solid ${vars.color.borderSubtle}`,
  borderRadius: vars.radius.sm,
  backgroundColor: vars.color.surface,
});

// Placeholder shown while the document loads or when it has no previewable
// bytes — keeps the card's shape without a broken frame.
export const previewEmpty = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "6rem",
  border: `1px dashed ${vars.color.borderSubtle}`,
  borderRadius: vars.radius.sm,
  color: vars.color.textMuted,
  fontSize: vars.fontSize.sm,
});

export const fields = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const fieldRow = style({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  gap: vars.space.md,
  paddingTop: vars.space.xs,
  paddingBottom: vars.space.xs,
  borderBottom: `1px solid ${vars.color.borderSubtle}`,
});

export const fieldValue = style({
  fontSize: vars.fontSize.sm,
  color: vars.color.textDefault,
  fontWeight: vars.fontWeight.medium,
  textAlign: "right",
});

export const fieldConfidence = style({
  fontSize: vars.fontSize.xs,
  color: vars.color.textMuted,
  fontWeight: vars.fontWeight.regular,
  marginLeft: vars.space.xs,
});

export const gateInput = style({
  width: "12rem",
});

// The exception gate's proposed cases (TMF-370), sitting above the id input
// they fill. Same label + stacked-rows shape as the fields block, so the two
// read as one card rather than a bolted-on panel.
export const candidates = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const candidateOptions = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: vars.space.xs,
});
